import { pick } from 'ramda';

export default pick([
  'autoplay',
  'controls',
  'controlsList',
  'loop',
  'muted',
  'preload',
  'src',
]);
